import { useEffect, useRef, useState } from 'react';
import EditComponent from './EmailsEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import { Button, Select, Space } from 'antd';
import dayjs from 'dayjs';
import antMessage from '../../../utils/extend/AntdNotification';
import SendAnEmail from './SendAnEmail';

//组件 
const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    /** api服务id */
    const apiId = 'emails';
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();
    const [emailSupplierData, setEmailSupplierData] = useState<any>();
    const [emailFolderData, setEmailFolderData] = useState<any>();
    const [isReceiveEmails, setIsReceiveEmails] = useState<boolean>(true);
    const [sendAnEmailVisible, setSendAnEmailVisible] = useState<boolean>(false);
    const [sendAnEmailData, setSendAnEmailData] = useState<any>();

    interface ShowPageDataOptions {
        /** 邮件供应商id */
        emailSupplierId?: string;
        /** 邮件文件夹id */
        emailFolderId?: string;
    }
    const [showPageData, setShowPageData] = useState<ShowPageDataOptions>({
        emailSupplierId: 'allEmailSupplier',
        emailFolderId: 'allEmailFolder'
    });

    useEffect(() => {
        if (!ref.current) return;
        let urlService = ref.current.defaultService;
        setDefaultService(urlService);
        setInitData(() => ref.current.initData);
        fetchApi.GET(urlService,
            {
                apiId: 'emailSupplier',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setEmailSupplierData([{ id: 'allEmailSupplier', supplierName: '所有' }, ...res.data]);
                }
            })
        fetchApi.GET(urlService,
            {
                apiId: 'generalData',
                apiVariable: 'emailFolder',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success) {
                    const { emailFolder } = res.data;
                    setEmailFolderData([{ id: 'allEmailFolder', name: '所有' }, ...emailFolder]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '供应商',
            dataIndex: 'emailSupplier',
            render: (val: any) => val?.supplierName
        },
        {
            title: '主题',
            dataIndex: 'subject'
        },
        {
            title: '发件人​',
            dataIndex: 'senderName'
        },
        {
            title: '收件人​',
            dataIndex: 'recipientsEmail'
        },
        {
            title: '发送时间',
            dataIndex: 'sentedAt',
            render: (val: any) => val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : ''
        },
        {
            title: '接收时间​',
            dataIndex: 'receivedAt',
            render: (val: any) => val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : ''
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '邮件',
        apiId,
        columns,
        showStates: true,
        showAdd: false,
        EditComponent,
        sendPageData: { showPageData },
        serviceId: 'business'
    };

    /**
     * 刷新
     * @param options 选项
     */
    const refresh = (options: ShowPageDataOptions) => {
        const { emailFolderId, emailSupplierId } = options;
        let currentShowPageData = showPageData;
        if (typeof emailFolderId !== 'undefined') {
            currentShowPageData = {
                ...currentShowPageData,
                emailFolderId
            };
        }
        if (typeof emailSupplierId !== 'undefined') {
            currentShowPageData = {
                ...currentShowPageData,
                emailSupplierId
            };
        }
        setShowPageData(currentShowPageData);
        InitData({
            apiId,
            sendPageData: {
                showPageData: currentShowPageData
            }
        });

    };

    return (
        <><Space>
            <Select
                showSearch
                placeholder="供应商"
                optionFilterProp="children"
                defaultValue={'allEmailSupplier'}
                onChange={(e) => {
                    refresh({
                        emailSupplierId: e
                    })
                    if (e === 'allEmailSupplier') {
                        setIsReceiveEmails(true);
                    } else {
                        setIsReceiveEmails(false);
                    }
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(emailSupplierData, {
                    itemName: 'supplierName'
                })}
            </Select>
            <Select
                showSearch
                placeholder="邮件文件夹"
                optionFilterProp="children"
                defaultValue={'allEmailFolder'}
                onChange={(e) => {
                    refresh({
                        emailFolderId: e
                    })
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(emailFolderData)}
            </Select>
            <Button type='primary' disabled={isReceiveEmails} onClick={() => {
                setSendAnEmailData({
                    emailSupplierId: showPageData.emailSupplierId
                })
                setSendAnEmailVisible(true);
            }}>发邮件</Button>
            <Button type='dashed' disabled={isReceiveEmails} onClick={() => {
                fetchApi.GET(defaultService,
                    {
                        apiId: 'emails',
                        apiExtend: 'receiveEmail',
                        apiData: {
                            emailSupplierId: showPageData.emailSupplierId
                        }
                    }).then(res => {
                        if (res.success === true) {
                            antMessage('success', '获取邮件成功', res.data);
                            if (InitData) {
                                InitData();
                            }
                        } else {
                            antMessage('error', '获取邮件失败', res.message);
                        }
                    })
            }}>收邮件</Button>
        </Space>
            <> </>
            <WebUniversal props={extendProps} ref={ref} />
            {sendAnEmailVisible ? (<SendAnEmail
                data={sendAnEmailData}
                onClose={() => setSendAnEmailVisible(false)} />) : null}
        </>
    )
}

export default WebComponent;
